import React from 'react';
import styles from './index.module.css';
import { Step } from './step';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { Grid, Column } from '../ui/Grid';
import { useForm } from 'react-hook-form';
import { useStore } from '../../lib/store';
import { ErrorMessage } from '@hookform/error-message';

export const StepContact = ({
  number,
  title,
  status
}) => {
  const { register, handleSubmit, formState: { errors, isValid } } = useForm({
    mode: 'onChange'
  });
  
  const { 
    increaseStep, 
    firstName,
    lastName,
    phone,
    email,
    setFirstName,
    setLastName,
    setEmail,
    setPhone,
  } = useStore();

  const canContinue = firstName && lastName && phone && email && isValid && Object.keys(errors).length === 0;

  const onSubmit = (data) => {
    const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if(!data.firstname || !data.lastname || !data.phone || 
       !data.email || !emailPattern.test(data.email) || 
       Object.keys(errors).length > 0) {
      return;
    }
    increaseStep(1);
  }

  return (
    <Step {...{number, title, status}}>
      <p className={styles.description}>First, we'll need to know a few simple things about you.</p>
      <form onSubmit={handleSubmit(async (data) => onSubmit(data))}>
        <Grid className={styles.inputGroup}>
          <Column span={[6]}>
            <Input 
              type="text" 
              name="firstname"
              label="First name"
              required
              {...register("firstname", {
                required: "First name is required",
                onChange: (e) => setFirstName(e.target.value)
              })} 
              error={errors.firstname}
            />
          </Column>
          <Column span={[6]}>
            <Input 
              type="text" 
              name="lastname"
              label="Last name"
              required
              {...register("lastname", {
                required: "Last name is required",
                onChange: (e) => setLastName(e.target.value)
              })} 
              error={errors.lastname}
            />
          </Column>
          <Column span={[12]}>
            <Input 
              type="tel" 
              name="phone"
              label="Phone number"
              defaultValue={phone || ''}
              required
              {...register(
                "phone", 
                {
                  required: "Phone number is required",
                  pattern: {
                    value: /^\+?[0-9\s-()]{6,}$/,
                    message: "Invalid phone number"
                  },
                  onChange: (e) => {
                    try {
                      if (e && e.target) {
                        setPhone(e.target.value);
                      }
                    } catch (error) {
                      console.error('Error updating phone:', error);
                    }
                  }
                },
              )} 
              error={errors.phone}
            />
          </Column>
          <Column span={[12]}>
            <Input 
              label="Email"
              type="text" 
              name="email"
              required
              {...register("email", {
                required: "Email is required",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "Invalid email address"
                },
                onChange: (e) => setEmail(e.target.value)
              })} 
              error={errors.email}
            />
          </Column>
        </Grid>
        {Object.keys(errors).length > 0 && (
          <div className={styles.errors}>
            <ErrorMessage
              errors={errors}
              name="firstname"
              render={({ message }) => <p>{message}</p>}
            />
            <ErrorMessage
              errors={errors}
              name="lastname"
              render={({ message }) => <p>{message}</p>}
            />
            <ErrorMessage
              errors={errors}
              name="phone"
              render={({ message }) => <p>{message}</p>}
            />
            <ErrorMessage
              errors={errors}
              name="email"
              render={({ message }) => <p>{message}</p>}
            />
          </div>
        )}
        <div className="actions">
          <Button 
            type="submit" 
            value="Submit" 
            icon="check"
            fullWidth
            disabled={canContinue ? false : true} 
          >
            {canContinue ? 'Continue to next step' : 'Please complete the form'}
          </Button>
        </div>
      </form>
    </Step>
  );
}